

var map = {};

var siteURL = "x";
    function render_map($el) {       
        var args = {
            center: new google.maps.LatLng(4.666064, -74.053018),
            backgroundColor: "#ffffff",
            zoom: 12,
            disableDefaultUI: false,
            zoomControl: true,
            zoomControlOptions: {
                position: google.maps.ControlPosition.RIGHT_BOTTOM,
                style: google.maps.ZoomControlStyle.SMALL
            },
            disableDoubleClickZoom: true,
            panControl: true,
            panControlOptions: {
                position: google.maps.ControlPosition.RIGHT_BOTTOM
            },
            mapTypeControl: true,
            scaleControl: false,
            scrollwheel: true,
            streetViewControl: true,
            draggable: true,
            overviewMapControl: false,
            mapTypeId: google.maps.MapTypeId.ROADMAP
        };
        map = new google.maps.Map($el[0], args);
        map.markers = [];
      
        	
        stores.forEach(function(punto) {
            add_marker(punto, map);
        });
        return map;
    }

    function add_marker(punto, map) {
        var latlng = new google.maps.LatLng(punto.latitud, punto.longitud);
        var icon = null;
        icon = "//www.tiendalego.cl/cdn/shop/t/54/assets/tienda.png?v=15941";
        var marker = new google.maps.Marker({
            //icon: new google.maps.MarkerImage(icon),
            optimized: false,
            position: latlng,
            map: map,
            zIndex: null,
            animation: google.maps.Animation.DROP,
            filter: {
                main: punto.ciudad,
                id: punto.punto_id,
            }
        });
      console.log(marker)
        map.markers.push(marker);
       
            google.maps.event.addListener(marker, "click", function() {
              console.log(marker.filter.id)  
              var point = stores.filter(store => store.punto_id == marker.filter.id)[0]
              console.log(point)
              $('#nombre_tienda').html('Toysmart ' + point.centro_comercial)
              $('#direccion_tienda').html(point.direccion)
              $('#local_tienda').html(point.local)
              $('#telefono_tienda').html(point.telefono)
              $('#correo_tienda').html(point.correo)
              $('#horario_l_j_tienda').html(point.horario_l_j)
              $('#horario_v_s_tienda').html(point.horario_v_s)
              $('#horario_d_f_tienda').html(point.horario_d_f)
              var src = point.imagen_tienda;
              $('#imagen_tienda').attr("src", src);
            });
            $(document).on("click", ".ac-main", function(e) {
                e.preventDefault();
                map.setZoom(12);
            });
    }

    function center_map(map) {
        var bounds = new google.maps.LatLngBounds();
        $.each(map.markers, function(i, marker) {
            var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
            bounds.extend(latlng);
        });
        map.fitBounds(bounds);
    }

    window.onload = function(){
      console.log('READY')
      var option = '';
      for (var i=0;i<cities.length;i++){
         option += '<option value="'+ cities[i].id + '">' + cities[i].name + '</option>';
      }
      console.log(option)
      $('#cities-filter').append(option);
        var map = null;
        $(".map-canvas").each(function() {
            map = render_map($(this));
        });
        $(document).on("click", ".filters a", function(e) {
            e.preventDefault();
            var
                $target = $(e.target),
                type = $target.data("filterby"),
                value = $target.data("filtervalue");
            map.setOptions({
                scrollwheel: true
            });
            $.each(map.markers, function() {
                if (type === "central" || type === "category" || type === "item") {
                    var grupo = this.filter[type]();
                    if (grupo.indexOf(value) !== -1) {
                        if (this.map === null) {
                            this.setMap(map);
                        }
                        map.panTo(this.getPosition());
                    } else {
                        this.setMap(null);
                    }
                } else {
                    if (this.filter[type] === value) {
                        if (this.map === null) {
                            this.setMap(map);
                        }
                        map.panTo(this.getPosition());
                    } else {
                        this.setMap(null);
                    }
                }
            });
        });
    $('#nombre_tienda').html('Toysmart ' + ' - ' + stores[0].centro_comercial);
	$('#direccion_tienda').html(stores[0].direccion);
	$('#local_tienda').html(stores[0].local);
	$('#telefono_tienda').html(stores[0].telefono);
	$('#correo_tienda').html(stores[0].correo);
	$('#horario_l_j_tienda').html(stores[0].horario_l_j);
	$('#horario_v_s_tienda').html(stores[0].horario_v_s);
	$('#horario_d_f_tienda').html(stores[0].horario_d_f);
    var src = stores[0].imagen_tienda;
	$('#imagen_tienda').attr("src", src);
    }
  
function changeCity(sel) {
  var city = cities.filter(city => city.id == sel.value)[0];
  console.log(city);
  map.panTo(new google.maps.LatLng(city.lat, city.lng)); //Make map global
  map.setZoom(13);
  
  
  var point = stores.filter(store => store.ciudad == city.name)[0]
  console.log('point', point);
  $('#nombre_tienda').html('Toysmart ' + ' - ' + point.centro_comercial);
  $('#direccion_tienda').html(point.direccion);
  $('#local_tienda').html(point.local);
  $('#telefono_tienda').html(point.telefono);
  $('#correo_tienda').html(point.correo);
  $('#horario_l_j_tienda').html(point.horario_l_j);
  $('#horario_v_s_tienda').html(point.horario_v_s);
  $('#horario_d_f_tienda').html(point.horario_d_f);
  var src = point.imagen_tienda;
  $('#imagen_tienda').attr("src", src);
}

  